// Tipos de integração exibidos na tela. Dialogflow só aparece para
// registros antigos: foi descontinuado e não pode mais ser criado.
export const INTEGRATION_TYPES = {
  typebot: {
    label: "Typebot",
    short: "TB",
    color: "#0042DA",
    role: "responde o cliente",
    description: "Um chatbot que conversa com o cliente",
  },
  n8n: {
    label: "n8n",
    short: "n8n",
    color: "#EA4B71",
    role: "recebe cópia das mensagens",
    description: "Envia cada mensagem para um fluxo do n8n",
  },
  webhook: {
    label: "Webhook",
    short: "WH",
    color: "#5B6B7F",
    role: "recebe cópia das mensagens",
    description: "Envia cada mensagem para qualquer URL (Make, Zapier, sistema próprio)",
  },
  dialogflow: {
    label: "Dialogflow",
    short: "DF",
    color: "#9AA5B5",
    role: "descontinuado",
    description: "Não é mais suportado",
    legacy: true,
  },
};

export const SELECTABLE_TYPES = ["typebot", "n8n", "webhook"];

export const typeInfo = (type) =>
  INTEGRATION_TYPES[type] || {
    label: type || "Desconhecido",
    short: "?",
    color: "#9AA5B5",
    role: "",
    description: "",
    legacy: true,
  };

// Mostra só o domínio: o caminho de URLs de webhook (Make, n8n) costuma ser
// a própria chave de acesso. "https://hook.make.com/abc123" -> "hook.make.com/…"
export const shortUrl = (url) => {
  if (!url) return "";
  try {
    const u = new URL(url);
    const hasPath = u.pathname.replace(/\/+$/, "") !== "" || u.search;
    return `${u.host}${hasPath ? "/…" : ""}`;
  } catch (err) {
    return "";
  }
};
